// extracted by css-extract-rspack-plugin
export default {"separator":"pFKF72qzioYT3Q6F","content":"R64o5FK6nEkVAcOQ","section":"h2FiwELcrSo82XZP"};